import { useFlashMessages } from "@towersystems/roam-common-native";
import { useCallback } from "react";
import {
  BarcodeScannerRootParamList,
  PerformStockCountRootParamList,
} from "@/types";
import Product from "@/utilities/data/model/Product";
import { BarcodeScannerRootScreen } from "../../../barcode-scanner/screens/BarcodeScannerRootScreen";
import { useCurrentCountContext } from "../../../../utilities/stock-count/hooks";
import { StockSelectionType } from "../../../../utilities/stock-count";
import { StackScreenProps } from "@react-navigation/stack";
import { BarcodeScannerScreenContext } from "../../../barcode-scanner/screens/context";
import React from "react";
import { ProductPartialRootScreenContext } from "../../../../utilities/products/context";

export type StockCountScannerScreenProps = StackScreenProps<
  PerformStockCountRootParamList & BarcodeScannerRootParamList,
  "StockCountScannerScreen"
>;

export const StockCountScannerScreen = ({
  navigation,
}: StockCountScannerScreenProps) => {
  const { showMessage } = useFlashMessages();
  const { updateStockSelection } = useCurrentCountContext();

  const handleSuccessfulScan = useCallback(
    (productId: string) => {
      navigation.navigate("ProductRootPartialScreen", {
        screen: "ProductPreviewScreen",
        params: {
          productId,
        },
      });
    },
    [navigation],
  );

  const handleConfirm = async (product: Product) => {
    try {
      updateStockSelection(
        {
          stockIdentifier: { productId: product.id },
          triggerUpdatedAt: true,
          selectionType: StockSelectionType.CAMERA_SCANNER,
        },
        () => {
          navigation.pop();
        },
      );
    } catch (e) {
      showMessage({
        message: "Failed to count stock",
        severity: "error",
      });
    }
  };

  return (
    <ProductPartialRootScreenContext.Provider
      value={{
        label: "Count Stock",
        primaryAction: handleConfirm,
      }}
    >
      <BarcodeScannerScreenContext.Provider
        value={{
          onNoProductSecondaryAction: {
            label: "Add Custom Product",
            onPress: (barcode: string) => {
              navigation.pop();
              navigation.navigate("CountProductModalRootScreen", {
                screen: "CountNonProductModalScreen",
                params: {
                  barcode: barcode,
                },
              });
            },
          },
        }}
      >
        <BarcodeScannerRootScreen onScanSuccess={handleSuccessfulScan} />
      </BarcodeScannerScreenContext.Provider>
    </ProductPartialRootScreenContext.Provider>
  );
};
